import Api from '@/services/Api'

export default {

  // Método que llama a la url para crear un chat
  getPatientRouteSheets () {
    return Api().get("/patient-route-sheet-statuses");
  },
  updatePatientRouteSheet (params) {
    return Api().put("/patient-route-sheet-statuses",params);
  },
  addPatientRouteSheet (params) {
    return Api().post("/patient-route-sheet-statuses",params);
  },
  getPatientRouteSheet(params) {
    return Api().get("/patient-route-sheet-statuses/"+params);
  },
  deletePatientRouteSheet (params) {
    return Api().delete("/patient-route-sheet-statuses/"+params);
  },
  getPatientRouteSheetByRouteSheets(params){
    return Api().get("/patient-route-sheet-statuses-by-route-sheet/"+params);
  },

}



// WEBPACK FOOTER //
// ./src/services/PatientRouteSheetStatusService.js